import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import Monitoring from "components/Monitoring/Monitoring";
import NextMonitoring from "components/Monitoring/NextMonitoring";
import * as unifiedProjectReducer from "containers/UnifiedProject/reducer";
import * as monitoringReducer from "containers/Monitoring/reducer";
import * as projectReducer from "containers/Project/reducer";
import * as setupReducer from "containers/Setup/reducer";

import { getIsMonitoringDemo } from "containers/Monitoring/reducer";

import { UNIFIED_PROJECT_STEPS } from "containers/UnifiedProject/reducer";

class MonitoringContainer extends React.Component {
  render() {
    const { isNext } = this.props;
    return isNext ? <NextMonitoring {...this.props} /> : <Monitoring {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    adjustAssumptions: () =>
      dispatch(unifiedProjectReducer.updateCurrentStep(ownProps.id, UNIFIED_PROJECT_STEPS.OPTIMIZE.id)),
    deleteUserFeedback: (userId) => dispatch(monitoringReducer.deleteUserFeedback(ownProps.id, userId)),
    updateMonitorViewMode: (mode) => dispatch(monitoringReducer.updateMonitorViewMode(ownProps.id, mode)),

    updateTargetValue: (value) => dispatch(monitoringReducer.updateTargetValue(ownProps.id, value)),
    updateGraphMode: (mode) => dispatch(monitoringReducer.updateGraphMode(ownProps.id, mode))
  };
};

const mapStateToProps = (state, ownProps) => {
  const id = ownProps.id;
  const monitor = monitoringReducer.getMonitor(state, ownProps.id);
  const selectedRunId = projectReducer.getRunId(state, ownProps.id);
  const segmentId = projectReducer.getSegmentId(state, ownProps.id);
  const optimized = projectReducer.getOptimized(state, id);
  const modelGroups = projectReducer.getModelGroups(state, id);

  const overallRunId = projectReducer.getOverallRunId(state, ownProps.id);

  return {
    monitorViewMode: monitoringReducer.getMonitorViewMode(state, ownProps.id),
    isContinuous: projectReducer.getIsContinuous(state, ownProps.id),
    warnings: monitoringReducer.getMonitorWarnings(state, ownProps.id),
    dataDriftWarnings: monitoringReducer.getDataDriftWarnings(state, ownProps.id),
    modelDriftWarnings: monitoringReducer.getModelDriftWarnings(state, ownProps.id),
    latestScenario: monitoringReducer.getLatestScenarios(state, ownProps.id),
    latestData: monitoringReducer.getLatestData(state, ownProps.id),
    monitoringData: monitoringReducer.getData(state, ownProps.id),
    segmentId: segmentId,
    scenarioIndex: getIsMonitoringDemo() ? projectReducer.getViewingScenarioIndex(state, ownProps.id) : undefined,
    userFeedback: monitoringReducer.getUserFeedback(state, ownProps.id),
    selectedDataset: setupReducer.getDatasetFromSetup(state, selectedRunId),
    compliancePlot: monitoringReducer.getCompliancePlot(state, ownProps.id, segmentId),
    setupLabels: setupReducer.getSetupLabels(state, selectedRunId),
    timePeriod: projectReducer.getDeployedSegmentTimePeriod(state, ownProps.id, segmentId),
    isLoading: monitoringReducer.getIsLoading(state, ownProps.id),

    targetValue: monitoringReducer.getTargetValue(state, ownProps.id),
    targetValueOptions: monitoringReducer.getTargetValueOptions(state, ownProps.id),
    graphMode: monitoringReducer.getGraphMode(state, ownProps.id),
    graphModeOptions: monitoringReducer.getGraphModeOptions(state, ownProps.id),
    setup: optimized && optimized.setup ? optimized.setup : setupReducer.getSetup(state, id),
    optimized: optimized,
    modelGroups: modelGroups,
    segmentConfusionMatrices: projectReducer.getSegmentConfusionMatrices(state, id),
    isOverallSegment: projectReducer.getIsOverallSegment(state, id),
    businessPredictionName: projectReducer.getBusinessPredictionName(state, ownProps.id),

    fairnessWarnings: monitoringReducer.getfairnessWarnings(state, ownProps.id),
    fairnessObjective: setupReducer.getFairnessObjective(state, overallRunId),
    fairnessToleranceBound: setupReducer.getFairnessToleranceBound(state, overallRunId)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MonitoringContainer);
